<!-- `ignore-export` no botão: é navegação, não conteúdo de relatório. -->
<div class="dfp-load-error" role="alert">
  <div class="dfp-load-error__icon"></div>
  <h4>{{ title }}</h4>
  <p>
    {{
      businessMessage ||
        'A consulta ao servidor falhou e seus dados continuam salvos. Use Tentar de novo; se o erro continuar, avise o suporte.'
    }}
  </p>
  <div class="dfp-load-error__action ignore-export">
    <app-button
      label="Tentar de novo"
      icon="pi pi-refresh"
      [fitContent]="true"
      (sendClick)="retry.emit()" />
  </div>
</div>
